export enum DeviceStatus {
  Online = "Online",
  Offline = "Offline",
  Inactive = "Inactive",
  Deactivated = "Deactivated"
}
